import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/lib/auth";
import { staffCall } from "@/hooks/use-staff";
import { type StartingPointFields } from "./staff-step9";
export type StartingPointPayload={employees:{id:string;expectedPaidUpTo:string|null;paidUpTo:string|null}[];mode?:"last_pay_day"};
export function useStaffStartingPoint() {
  const cache=useQueryClient(),{currentWorkspace}=useAuth();
  return useMutation({
    mutationFn:(body:StartingPointPayload)=>staffCall<{employees:({id:string}&StartingPointFields)[]}>("POST","/api/staff/paid-up-to",body),
    onSuccess:async()=>{await Promise.all([
      cache.invalidateQueries({queryKey:["/api/staff/bootstrap",currentWorkspace?.id]}),
      cache.invalidateQueries({queryKey:["branch-cash"]}),
    ])},
  });
}
